import { DatePicker as AntDatePicker } from 'antd'
import locale from 'antd/es/date-picker/locale/vi_VN'
import moment from 'moment'
import 'moment/locale/vi'
import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

moment.locale('vi')

const StyledDatePicker = styled(AntDatePicker)`
  :focus {
    border: none;
    border-bottom: 1px solid var(--color-primary-109);
    border-radius: 0;
    box-shadow: none;
  }
  height: 36px;
  border: none;
  border-bottom: 1px solid var(--color-gray-103);
  border-radius: 0;
  padding: 8px 0;
  &.ant-picker-focused {
    border-bottom: 1px solid var(--color-primary-109) !important;
    box-shadow: none !important;
  }
  .ant-picker-clear {
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &.prevent-edit.ant-picker.ant-picker-disabled {
    color: inherit;
    .ant-picker-input input {
      color: inherit;
    }
    background-color: inherit;
  }
  &.prevent-edit {
    cursor: not-allowed;
    .ant-picker-input {
      pointer-events: none;
      caret-color: transparent;
    }
  }
`

const StyledLabel = styled.label`
  color: var(--color-gray-111);
  font-weight: 600;
  font-size: 1.4rem;
  span {
    color: var(--color-red-107);
  }
`
interface IProps {
  title?: string | ReactNode
  placeholder?: string
  required?: boolean
  defaultValue?: moment.Moment
  preventInput?: boolean
  disabled?: boolean
  max?: Date
  min?: Date
  format?: string
  [key: string]: any
}

const DatePicker = (props: IProps) => {
  const { t } = useTranslation()
  const {
    title,
    required,
    preventInput,
    placeholder,
    disabled,
    className,
    max,
    min,
    format = 'DD/MM/YYYY',
    ...resProps
  } = props
  const handleDisabledDate = (currentDate: any) => {
    if (max && min) {
      return !(
        new Date(currentDate).getTime() > min?.getTime() &&
        new Date(currentDate).getTime() < max?.getTime()
      )
    }

    if (min) {
      return new Date(currentDate).getTime() < min?.getTime()
    }

    if (max) {
      return new Date(currentDate).getTime() > max?.getTime()
    }

    return false
  }
  return (
    <>
      <StyledLabel>
        {typeof title === 'string' ? t(title) : title}
        {required && <span>*</span>}
      </StyledLabel>
      <StyledDatePicker
        locale={locale}
        placeholder={t(placeholder || '')}
        suffixIcon={<img src="images/ic-calendar.svg" alt="" />}
        className={`${className} ${preventInput ? 'prevent-edit' : ''}`}
        disabled={disabled}
        format={format}
        disabledDate={handleDisabledDate}
        open={preventInput ? false : undefined}
        {...resProps}
      />
    </>
  )
}

export default DatePicker
